import { useState } from "react";
import '../App.css';

function Form(props){
const initialPlayers = 

{
    player_1:"",
    player_2:""
}
; 

const [player,setPlayer]=useState(initialPlayers)


function handleChange(event){
    event.preventDefault();
const name = event.target.name;
const value = event.target.value;
return setPlayer((values)=>({...values,[name]:value}))

}

function handleSubmit(event){
    event.preventDefault();
    
    props.addPlayers(player)
}



return(
    <>
    <form className="row g-3" onSubmit={handleSubmit}>
<div className="col-md-6">
<label className="form-label fw-bold fs-5 text-white" htmlFor="player_1">Player-1</label>
      <input className="form-control" type="text" name="player_1" value= {player.player_1} onChange={handleChange} />
</div>
<div className="col-md-6">  
      <label className="form-label fw-bold fs-5 text-white" htmlFor="player_2">Player-2</label>
      <input className="form-control" type="text" name="player_2" value= {player.player_2} onChange={handleChange} />
      </div> 

      <div className="col-12">

      <input className="btn btn-outline-warning fw-bold btn-lg" type ="submit" value="Lets Play"/>

      </div>

    </form>
    
    </>
)






}
export default Form;